"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithTitleActiveCourseListArgs = exports.WithSelectionExample = exports.WithCoursesActiveListArgs = exports.IlActiveCourseList = exports.EmptyCourseActiveListArgs = exports.DefaultCoursePropsList = exports.DefaultActiveCourseListWithRightIndicatorArgs = exports.DefaultActiveCourseListWithLeftIndicatorArgs = void 0;
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var il_active_course_list_1 = require("./il-active-course-list");
var EmptyCourseActiveListArgs = {};
exports.EmptyCourseActiveListArgs = EmptyCourseActiveListArgs;
var DefaultCoursePropsList = [
    {
        key: '123-asd-123',
        customIconType: enums_1.CustomIconTypeEnum.CALVERT_MATH,
        courseName: 'Math',
        assignmentName: 'Calculus II',
        startDate: new Date('2022-06-01T00:00:00'),
        endDate: new Date('2022-06-08T00:00:00'),
        weekdaySelections: [1, 3, 6],
    },
    {
        key: '234-asd-124',
        customIconType: enums_1.CustomIconTypeEnum.CALVERT_ELECTIVE,
        courseName: 'Computer Science',
        assignmentName: 'Programing Language I',
        startDate: new Date('2022-07-01T00:00:00'),
        endDate: new Date('2022-07-08T00:00:00'),
        weekdaySelections: [2, 3, 4],
    },
    {
        key: '122-asd-123',
        customIconType: enums_1.CustomIconTypeEnum.CALVERT_GEOGRAPHY,
        courseName: 'History & Geography',
        assignmentName: 'World Geography',
        startDate: new Date('2022-08-01T00:00:00'),
        endDate: new Date('2022-08-08T00:00:00'),
        weekdaySelections: [2, 3, 4],
    },
    {
        key: '123-asd-12123',
        customIconType: enums_1.CustomIconTypeEnum.CALVERT_LANGUAGE,
        courseName: 'Grammar',
        assignmentName: 'Verb Tenses I',
        startDate: new Date('2022-09-01T00:00:00'),
        endDate: new Date('2022-09-08T00:00:00'),
        weekdaySelections: [1, 2, 3],
    },
    {
        key: '123-aaa-123',
        customIconType: enums_1.CustomIconTypeEnum.CALVERT_SCIENCE,
        courseName: 'Chemistry',
        assignmentName: 'Chemistry I',
        startDate: new Date('2022-10-01T00:00:00'),
        endDate: new Date('2022-10-08T00:00:00'),
        weekdaySelections: [1, 2, 3, 4, 5],
    },
];
exports.DefaultCoursePropsList = DefaultCoursePropsList;
var WithCoursesActiveListArgs = __assign(__assign({}, EmptyCourseActiveListArgs), { courses: DefaultCoursePropsList, selectedCourse: DefaultCoursePropsList[1] });
exports.WithCoursesActiveListArgs = WithCoursesActiveListArgs;
var WithTitleActiveCourseListArgs = __assign(__assign({}, WithCoursesActiveListArgs), { title: 'Active Courses' });
exports.WithTitleActiveCourseListArgs = WithTitleActiveCourseListArgs;
var DefaultActiveCourseListWithRightIndicatorArgs = __assign(__assign({}, WithTitleActiveCourseListArgs), { showRightIndicator: true });
exports.DefaultActiveCourseListWithRightIndicatorArgs = DefaultActiveCourseListWithRightIndicatorArgs;
var DefaultActiveCourseListWithLeftIndicatorArgs = __assign(__assign({}, WithTitleActiveCourseListArgs), { showLeftIndicator: true });
exports.DefaultActiveCourseListWithLeftIndicatorArgs = DefaultActiveCourseListWithLeftIndicatorArgs;
var IlActiveCourseList = (0, get_component_1.getComponent)(il_active_course_list_1.ILActiveCourseList, WithTitleActiveCourseListArgs);
exports.IlActiveCourseList = IlActiveCourseList;
function WithSelectionExample(_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    var _b = react_1.default.useState(), selectedCourse = _b[0], setSelectedCourse = _b[1];
    react_1.default.useEffect(function () {
        setSelectedCourse(props.selectedCourse);
    }, [props.selectedCourse]);
    function selectCourse(course) {
        var sCourse = course;
        if ((selectedCourse === null || selectedCourse === void 0 ? void 0 : selectedCourse.key) === (course === null || course === void 0 ? void 0 : course.key)) {
            sCourse = undefined;
        }
        setSelectedCourse(sCourse);
        onClick && onClick(sCourse);
    }
    return react_1.default.createElement(il_active_course_list_1.ILActiveCourseList, __assign({}, props, { selectedCourse: selectedCourse, onClick: selectCourse }));
}
exports.WithSelectionExample = WithSelectionExample;
